export enum EmptyValues {
  DASH = '-',
}
